import request from '@/utils/request';

//查询字段
export function getFieldList(values) {
  return request('/decision/field', {
    method: 'GET',
    params: values,
  });
}
//添加字段
export function addField(values) {
  return request('/decision/field', {
    method: 'POST',
    data: JSON.parse(JSON.stringify(values.values)),
  });
}
//更新字段 /decision/field/{fieldId}
export function editField(values) {
  return request('/decision/field/' + values.id, {
    method: 'PUT',
    data: values,
    // data: JSON.parse(JSON.stringify(values.values)),
  });
}
//删除字段
export function deleteField(id) {
  return request(`/decision/field/${id}`, {
    method: 'DELETE',
  });
}
// 字段模型级联下拉接口
export function getFieldModel() {
  return request('/decision/field/fieldModel', {
    method: 'GET',
  });
}
